function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { useTheme } from '@veneer/theme';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
var useStyles = _ref => {
  var {
    type
  } = _ref;
  var theme = useTheme();
  var isHc = theme.mode === 'contrast';
  var types = {
    help: 'primary',
    informative: 'neutral',
    positive: 'positive',
    negative: 'negative',
    warning: 'warning'
  };
  var {
    background
  } = theme.palette[types[type]];
  var iconColor = type === 'informative' ? theme.palette.foreground.light : theme.palette[types[type]].default;
  return React.useMemo(() => ({
    root: _objectSpread(_objectSpread({
      backgroundColor: background,
      borderColor: 'transparent',
      borderRadius: theme.borderRadius,
      color: theme.palette.foreground.default,
      '.vn-notification__description': {
        color: theme.palette.foreground.medium
      },
      '.vn-notification__text': {
        marginLeft: 0
      }
    }, isHc && {
      borderColor: theme.palette.foreground.default
    }), highContrastMediaQuery(theme)),
    icon: _objectSpread({
      fill: type && iconColor,
      marginRight: theme.orbitalThree,
      marginTop: "calc(".concat(theme.orbitalThree, " - 1px)")
    }, isHc && _objectSpread({}, type === 'help' && {
      fill: theme.palette.foreground.light
    }))
  }), [background, iconColor, isHc, theme, type]);
};
export default useStyles;